import React from "react";
import * as Icons from "react-bootstrap-icons";
import OpenSee from "../Assets/Images/opensee.svg";
import Rari from "../Assets/Images/Rari.svg";

export default function GetIcon({ iconKey }) {
  return (
    <>
      {
        {
          TwitterX: <Icons.TwitterX />,
          Whatsapp: <Icons.Whatsapp />,
          Telegram: <Icons.Telegram />,
          Facebook: <Icons.Facebook />,
          EnvelopePaper: <Icons.EnvelopePaper />,
          OpenSee: (
            <img src={OpenSee} style={{ width: "23px", height: "23px" }} />
          ),
          Rarible: <img src={Rari} style={{ width: "23px", height: "23px" }} />,
          Instagram: <Icons.Instagram />,
          Discord: <Icons.Discord />,
          Reddit: <Icons.Reddit />,
          Medium: <Icons.Medium />,
          Threads: <Icons.Threads />,
          Youtube: <Icons.Youtube />,
          Check: <Icons.CheckCircle />,
          Void: <Icons.DashCircle />,
        }[iconKey]
      }
    </>
  );
}
